module.exports = __webpack_public_path__ + "media/images/guide-thumb-8-f6b83b1ee5a1622de7f1b8af50d04579.png";